import React from 'react';
import { DataList } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../../useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { columnConfigs, DEFAULT_CONFIG } from './listConfig';

const ListAsset: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	const { getAssetsData } = useService();

	return (
		<DataList
			fetchData={getAssetsData}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			rowHeight={100}
			defaults={DEFAULT_CONFIG}
			disablePagination={false}
			disablePaginationSelect={false}
			entity={LIST_ENTITY_NAMES.UTILITIES_ASSET_UPLOAD}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default ListAsset;
